import type { PageContent, TimelineItem } from '../schema';

export const timeline = [
  {
    year: '1950s',
    title: 'The Beginnings',
    description:
      'Started with handlooms in Elampillai, crafting pure silk sarees that gained prominence for their intricate patterns and luxurious textures.',
  },
  {
    year: '1960s',
    title: 'Innovation in Weaving',
    description:
      'Acquired Mysore looms and introduced semi-automated weaving, bringing signature designs like "Naar Pattu" to life, and expanded production capabilities.',
  },
  {
    year: '1970s',
    title: 'Expanding Horizons',
    description:
      'Established Mahavishnu Textiles in Salem, bridging traditional artistry with modern market demands and catering to customers across India and abroad.',
  },
  {
    year: '1990s',
    title: 'Evolving with Market Trends',
    description:
      'Adapted to emerging fabrics like polyester blends while sustaining the legacy of handloom excellence. Introduced chudi materials and blouse pieces for contemporary audiences.',
  },
  {
    year: '2000s',
    title: 'A Strategic Pivot',
    description:
      'Shifted from in-house production to sourcing high-quality sarees and fabrics from trusted suppliers, focusing on wholesale distribution to streamline operations.',
  },
  {
    year: '2010s',
    title: 'A Visionary Approach',
    description:
      'Laid the foundation for a retail-focused business model, incorporating customizable gifting solutions and curated collections tailored to modern preferences.',
  },
  {
    year: '2019',
    title: 'Sree Silks Retail Launch',
    description:
      'Opened our flagship retail store in Jalakandapuram, blending traditional saree-making, offering premium gifting options and bespoke designs.',
  },
  {
    year: 'Today',
    title: 'Innovating for the Future',
    description:
      'A trusted name in ethnic wear, celebrating heritage while innovating for a global audience. Expanding into online platforms to connect with customers worldwide.',
  },
] satisfies readonly TimelineItem[];

export const journeyPageContent = {
  id: 'journey',
  title: 'Our Journey Through Generations',
  description: 'The history and evolution of Sree Silks through generations of silk craftsmanship.',
  sections: [
    {
      id: 'timeline',
      title: 'Our Journey Through Generations',
      description: 'From handlooms in Elampillai to a modern customer-first silk house.',
    },
  ],
} satisfies PageContent;
